import n from "vue";
import { deepAssign as d } from "../utils/deep-assign.js";
import r from "./lang/zh-CN.js";
var a = n.prototype,
  o = n.util.defineReactive;
o(a, "$vantLang", "zh-CN");
o(a, "$vantMessages", {
  "zh-CN": r
});
var p = {
  messages: function messages() {
    return a.$vantMessages[a.$vantLang];
  },
  use: function use(e, i) {
    var t;
    a.$vantLang = e, this.add((t = {}, t[e] = i, t));
  },
  add: function add(e) {
    e === void 0 && (e = {}), d(a.$vantMessages, e);
  }
};
export { p as default };
